<!-- 关于我们 -->
<template>
	<div class="aboutUs">
		<div class="imgBg"></div>
		<div class="aboutUsMain">
			<div v-for="(item,index) in menus"  :key="index" class="aboutUsSingle">
				<h2>{{item.name}}</h2>
				<p class ="title">{{item.title2}}</p>
				<div v-if="item.type == 1" class="mainConCompany">
					<p class="fontStyle">{{$t('intro.p1')}}</p>
					<p class="fontStyle">{{$t('intro.p2')}}</p>
					<p class="fontStyle">{{$t('intro.p3')}}</p>
				</div>
				<div  v-if="item.type == 2" class="mainConTeam">
					<div class="teamCon">
						<div class="teamCenter">
							<div class="teamImg">
								<img src="../assets/img/team.png" alt="">
							</div>
							<div class="teamCenterP">
								<p class="fontStyle">{{$t('aboutusTeam.p1')}}</p>
								<p class="fontStyle">{{$t('aboutusTeam.p2')}}</p>
								<p class="fontStyle">{{$t('aboutusTeam.p3')}}</p>
								<p class="fontStyle">{{$t('aboutusTeam.p3')}}</p>
							</div>
						</div>
					</div>
					
				</div>
				<div  v-if="item.type == 3" class="mainConTeam3">
					<p>{{$t('aboutusPurpose.p1')}}</p>
					<p>{{$t('aboutusPurpose.p2')}}</p>
					<p>{{$t('aboutusPurpose.p3')}}</p>
				</div>
			</div>	
			
		</div>
	</div>
</template>

<script>
	export default {
	  components: {},
	  data() {
	    return {
		}
	  },
	  computed: {
			menus() {
				return this.$t('aboutUsMenus'); // 获取翻译的menus
			}
		},
	  methods:{
		  
	  }
	}
</script>

<style scoped lang="scss">
.teamImg{
	width:400px;
	overflow: hidden;
	
	img{
		width: 100%;
	}
}
  .aboutUs{
	position: relative;
  }
  .imgBg{
	background-image: url('../assets/img/aboutUsbanner.jpg');
  }
  .aboutUsMain{
	box-sizing: border-box;
	margin:100px auto;
	h2{
		text-align: center;
	}
	p.title{
		text-align: center;
		margin-bottom:90px;
	}
  }
  
.fontStyle{
	text-align: left;
	text-indent: 2ch;
	color:#5c6165;
	margin-bottom: 10px;
}
.mainConCompany{
	margin: 0 auto;
	width: 1100px;
	line-height: 30px;
}
.mainConTeam{
	
	.teamCon{
		width: 100%;
		height:450px;
		background-color:#0066ca ;
		overflow: hidden;
		.teamCenter{
			width: 1200px;
			margin:0 auto;
			display: flex;
		}
		.teamCenterP{
			height:450px;
			box-sizing: border-box;
			width: 660px;
			padding-top:80px;
			padding-left:40px;
			// display: flex; 
			// align-items: center; 
 			// justify-content: center; 
			// flex-direction: column;
			p{
				// flex: 1;
				// width: 600px;
				// border:1px solid red;
				color:#fff;
		}
		}
		
	}
}
.mainConTeam3{
	max-width:1200px;
	margin: 0 auto;
	p{
		text-align: center;
		line-height: 32px;
	}
}

</style>